import { render } from "./PassUpdateForm.vue?vue&type=template&id=08dfe4d6"
import script from "./PassUpdateForm.vue?vue&type=script&lang=js"
export * from "./PassUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__